// @flow
import React, { Component } from 'react';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { sanitizeRouteParams } from 'metaup/routing/routingUtils';
import type { Routes } from 'metaup/routing/routingUtils';
import { createOfflineToken } from './model/OfflineToken.client';
import { loadAllOffices } from '../org/redux/Office.redux';
import OfflineTokenCreatePageView from './views/OfflineTokenCreatePageView';
import type { OfflineTokenCreatePageViewProps } from './views/OfflineTokenCreatePageView';

type OfflineTokenCreateState = {
  createdToken: ?string,
}

const tokenShape = `{ id token officeId isActive createdAt }`;

const initialState = { createdToken: null };

const ACTION_SET_CREATED_TOKEN = 'offlineTokens/create/ACTION_SET_CREATED_TOKEN';

export async function submitCreateToken(values: Object) {
  const result = await createOfflineToken(values, tokenShape);
  return { type: ACTION_SET_CREATED_TOKEN, createdToken: result.token };
}

export function offlineTokenCreateReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_SET_CREATED_TOKEN:
      return { ...state, createdToken: action.createdToken };
    default: return state;
  }
}

const OfflineTokenCreatePage = connect(
  ({ offlineTokens, org }) => ({
    offices: org.office.all,
    createdToken: offlineTokens.create.createdToken,
  }),
)(class extends Component<OfflineTokenCreatePageViewProps> {
  constructor(props) {
    super(props);
    props.dispatch(loadAllOffices());
  }
  render() {
    return (
      <OfflineTokenCreatePageView
        {...this.props}
        onSubmit={(values) => this.props.dispatch(submitCreateToken(values))}
      />
    );
  }
});

export function offlineTokenCreatePageRoutes(): Routes {
  return [{
    title: 'Создание офлайн токена',
    path: '/offline/tokens/create/',
    isEnabled: ({ isUser }) => isUser,
    render: params => <OfflineTokenCreatePage {...sanitizeRouteParams(params, {})} />,
    design: null,
  }];
}
